import React, { useEffect, useState } from "react";
import {
  invitation_accept_or_reject,
  received_invitations,
} from "../../DAL/manage-users/manage-users";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import CircularLoader from "../../components/loader/CircularLoader";
import InvitationCard from "./components/InvitationCard";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import { user_logout } from "../../DAL/auth/auth";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Invitations() {
  const {
    userInfo,
    fetctUserDetail,
    handleSwitchProfile,
    setUserInfo,
    STOP_SOCKET_FORCEFULLY,
    setUserAPIData,
    clearLocalStorageAndMoveLogin,
    setUpdateInvitationListOnNotification,
  } = useIds();
  const [invitationsList, setInvitationsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [submittingResp, setSubmittingResp] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleGetInvitationsList = async () => {
    const resp = await received_invitations(userInfo.email);
    if (resp.code == 200) {
      setInvitationsList(resp.data.invitation);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setIsLoading(false);
  };

  const handleInvitationRespoce = async (
    value,
    invitation,
    callBack = () => {}
  ) => {
    setSubmittingResp(true);
    const postData = {
      client_id: userInfo._id,
      response: value,
    };

    const resp = await invitation_accept_or_reject(invitation._id, postData);
    if (resp.code == 200) {
      enqueueSnackbar(resp.message, { variant: "success" });
      if (value == "accepted") {
        if (
          userInfo.role == "internal_user" &&
          invitation?.client_object?._id
        ) {
          handleSwitchProfile(invitation.client_object._id);
          return;
        } else {
          fetctUserDetail();
        }
      } else if (value == "rejected" && userInfo.role == "internal_user") {
        setUserAPIData(null);
        setUserInfo(null);
        STOP_SOCKET_FORCEFULLY();
        localStorage.clear();
        navigate("/login");
        return;
      }

      handleGetInvitationsList();
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
      handleGetInvitationsList();
    }
    setSubmittingResp(false);
    callBack();
  };

  useEffect(() => {
    const paramsUserId = searchParams.get("user_id");

    if (paramsUserId && paramsUserId != userInfo?.profile_id) {
      clearLocalStorageAndMoveLogin();
      return;
    } else {
      if (paramsUserId) {
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState(null, "", newUrl);
      }
    }
    if (userInfo?.email) {
      setIsLoading(true);
      handleGetInvitationsList();
    }
  }, []);

  const handleUpdateInvitationList = (
    requestData,
    setList = setInvitationsList
  ) => {
    if (requestData?.deleted_invitation_id) {
      setList((prev) =>
        prev.filter((item) => item._id != requestData.deleted_invitation_id)
      );
      return;
    } else if (requestData?.update_invitation) {
      setList((prev) =>
        prev.map((item) =>
          item._id === requestData.update_invitation._id
            ? { ...item, ...requestData.update_invitation }
            : item
        )
      );
    } else {
      setList((prev) => [requestData, ...prev]);
    }
  };
  useEffect(() => {
    // Register the function
    setUpdateInvitationListOnNotification(() => (data) => {
      handleUpdateInvitationList(data, setInvitationsList);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateInvitationListOnNotification(() => () => {});
    };
  }, [invitationsList]);

  return (
    <>
      <div className="container-fluid mt-3">
        <div className="row mt-0">
          <div className="col-12 heading-main">
            <h2>Invitations</h2>
            <p>Review and manage the invitations you’ve received.</p>
          </div>

          {isLoading ? (
            <CircularLoader />
          ) : (
            <div className="col-12">
              {invitationsList.length > 0 ? (
                invitationsList.map((obj) => (
                  <>
                    <InvitationCard
                      invitation={obj}
                      onAccept={(invitation) => {
                        handleInvitationRespoce("accepted", invitation);
                      }}
                      onReject={(invitation, callBack = () => {}) => {
                        handleInvitationRespoce(
                          "rejected",
                          invitation,
                          callBack
                        );
                      }}
                      submittingResp={submittingResp}
                    />
                  </>
                ))
              ) : (
                <RecordNotFound title={"No Invitation"} />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
